import styled, { css } from 'styled-components';
import { getColor, typeScale, StyleVars } from 'core/utils';

const UserContent = styled.div`
	margin: 16px 0;
	font-size: 16px;
	line-height: 22px;
	color: ${getColor("gray")};
	letter-spacing: 0.2px;

	${({ marginBottom }) => marginBottom && css`
		margin-bottom: 32px;
	`}

	@media(max-width: ${StyleVars.screenSm}) {
		font-size: 16px;
		margin-bottom: ${typeScale(2)};
	}

	h1 {
		font-size: 33px;
		line-height: 29px;
		margin-bottom: 20px;
		font-weight: 700;
		@media(max-width: 767px) {
			font-size: 25px;
			line-height: 24px;
		}
	}

	h2 {
		font-size: 25px;
		line-height: 24px;
		margin-bottom: 20px;
		font-weight: 700;
		@media(max-width: 767px) {
			font-size: 19px;
			line-height: 20px;
		}
	}

	h3 {
		font-size: 19px;
		line-height: 20px;
		margin-bottom: 20px;
		font-weight: 700;
		@media(max-width: ${StyleVars.screenSm}) {
			font-size: 16px;
			line-height: 22px;
			margin-bottom: ${typeScale(1)};
		}
	}

	h4 {
		font-size: 16px;
		line-height: 22px;
		margin-bottom: 20px;
		@media(max-width: 767px) {
			font-size: 14px;
			line-height: 22px;
		}
	}

	ul {
		list-style: none;
		padding: 0;
		margin: 0;
		margin-top: ${typeScale(2)};
		@media(max-width: ${StyleVars.screenSm}) {
			margin-top: ${typeScale(1)};
		}
	}

	li {
		position: relative;
		padding-left: 0.8em;
		&:before {
			content: '•';
			position: absolute;
			top: 0;
			left: 0;
		}
	}

	p {
		margin: 0;
		font-size: ${typeScale(2)};
	}

	p:not(:first-child) {
		margin-top: 18px;
	}

	blockquote {
		margin: 18px 0;
		border-left: 8px solid ${getColor('pelorous')};
		padding-left: 16px;
	}
`;

export default UserContent;
